import React, { useState } from "react";
import PlanToggle from "../shared/PlanToggle";
import SellPlanCard from "../shared/SellPlanCard";
import { XS_PIXEL_MAX } from "../../constants/breakpoints";
import useWindowSize from "./hooks/useWindowSize";

const SellPlanPageCardContainer = ({
  aPlusConfig,
  teacherConfig,
  groupInfoLink,
  teacherFocus,
  loggedIn
}) => {
  const [selectedPlan, setSelectedPlan] = useState("annual");
  const { width: screenSize } = useWindowSize();

  const changeSelectedPlan = () => {
    setSelectedPlan((prevPlan) =>
      prevPlan === "annual" ? "monthly" : "annual"
    );
  };

  const paidPlanDetails = aPlusConfig[selectedPlan];
  const teacherPlanDetails = teacherConfig[selectedPlan];

  return (
    <div className="plan-cards-container">
      <div className="toggle-container">
        <PlanToggle onToggle={changeSelectedPlan} selectedPlan={selectedPlan} />
      </div>
      <div className="plan-cards-container-content">
        <div className="plan-cards">
          {teacherFocus ? null : (
            <div className="paid-card">
              <SellPlanCard
                teacherFocus={teacherFocus}
                selectedPlan={selectedPlan}
                benefits={aPlusConfig.benefits}
                planType={aPlusConfig.planType}
                planCode={paidPlanDetails.code}
                annualPrice={paidPlanDetails.total}
                cents={paidPlanDetails.cents}
                dollars={paidPlanDetails.dollars}
                groupInfoLink={groupInfoLink}
                loggedIn={loggedIn}
                showGroupInfoLink={!teacherFocus && screenSize > XS_PIXEL_MAX}
              />
            </div>
          )}

          <div className="paid-card">
            <SellPlanCard
              teacherFocus={teacherFocus}
              selectedPlan={selectedPlan}
              benefits={teacherConfig.benefits}
              planType={teacherConfig.planType}
              planCode={teacherPlanDetails.code}
              annualPrice={teacherPlanDetails.total}
              cents={teacherPlanDetails.cents}
              dollars={teacherPlanDetails.dollars}
              groupInfoLink={groupInfoLink}
              loggedIn={loggedIn}
              showGroupInfoLink={teacherFocus || screenSize < XS_PIXEL_MAX}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellPlanPageCardContainer;
